import type { OriginalQuestionData } from "../types/question";

export const extractTopicsFromUserPrompt = (userPrompt?: string) => {
	if (!userPrompt) {
		return undefined;
	}
	const regex = /\[([^)]+)\]/;
	const matches = userPrompt.match(regex);
	return matches ? matches[1] : undefined;
};

export const getInitialQuestionMarkdown = ({
	stem,
	choices,
}: OriginalQuestionData) => {
	const choicesText = choices
		.map((choice, index) => {
			const choiceStem = choice.text;
			if (choice.isCorrect) {
				return `${index + 1}. ✅ **${choiceStem}**`;
			}
			return `${index + 1}. ${choiceStem}`;
		})
		.join("\n");

	return `${stem}\n\n${choicesText}`;
};

/**
 * Interpolates variables into a template string using {{variable}} syntax
 * @param template - The template string containing variables in {{variable}} format
 * @param variables - Object mapping variable names to their values
 * @returns The template with all variables replaced with their corresponding values
 * @example
 * interpolateString("Hello {{name}}", { name: "World" }) // Returns "Hello World"
 */
export const interpolateString = (
	template: string,
	variables: Record<string, string>,
) => {
	return template.replace(/\{\{(\w+)\}\}/g, (_, key) => variables[key] ?? "");
};
